// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import styles from "../styles/DocumentList.module.css";
// import { FaArrowLeft, FaSearch, FaDownload, FaFilter, FaCalculator, FaFilePdf } from "react-icons/fa";
// import { useAppContext } from "../context";
// import FilterPopup from "../components/FilterPopup";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFilter as faFilterIcon } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";

// export default function DocumentList() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { selectedCategory, searchText, setSearchText, filter, setFilter, setSelectedCategory } = useAppContext();
//   const [showFilter, setShowFilter] = useState(false);
//   const [documents, setDocuments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
  
//   // Track if we came from a tab click or filter apply
//   const navigationSource = useRef(null);

//   // When component mounts, check if we have selectedCategory from context
//   useEffect(() => {
//     // If we have a selectedCategory (from tab click) and no filter is applied
//     if (selectedCategory && !filter.mainCategory) {
//       navigationSource.current = 'tab';
//     }
//     // If we have filter applied
//     else if (filter.mainCategory) {
//       navigationSource.current = 'filter';
//       // Ensure selectedCategory matches filter
//       if (selectedCategory !== filter.mainCategory) {
//         setSelectedCategory(filter.mainCategory);
//       }
//     }
    
//     if (searchText) setSearchTerm(searchText);
//   }, []);

//   useEffect(() => {
//     if (searchText) setSearchTerm(searchText);
//   }, [searchText]);

//   useEffect(() => {
//     fetchDocuments();
//   }, [selectedCategory, filter, searchTerm]);

//   const fetchDocuments = async () => {
//     setLoading(true);
//     try {
//       // Priority: filter takes precedence over selectedCategory if both exist
//       const effectiveCategory = filter.mainCategory || selectedCategory || '';
      
//       const params = {
//         category: effectiveCategory,
//         subCategory: filter.subCategory || '',
//         subSubCategory: filter.subSubCategory || '',
//         search: searchTerm || ''
//       };

//       const response = await axios.get("https://tph-api-server2.vishvaconnect.site/getDocuments.php", { params });
//       setDocuments(response.data);
//     } catch (error) {
//       console.error("Error fetching documents:", error);
//     }
//     setLoading(false);
//   };

//   const handleBack = () => {
//     // Reset everything when going back
//     setFilter({
//       mainCategory: "",
//       subCategory: "",
//       subSubCategory: "",
//     });
//     setSelectedCategory(null);
//     setSearchText("");
//     navigate("/");
//   };

//   const handleCalculatorClick = () => {
//     navigate("/area-convertor");
//   };

//   const filteredDocs = documents.filter(doc =>
//     searchTerm.trim() === "" || doc.title.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleDocumentClick = (doc) => {
//     // Extract the actual PDF URL from the Google Docs viewer URL if needed
//     let pdfUrl = doc.downloadLink;

//     // If it's already a Google Docs URL, extract the original PDF URL
//     if (pdfUrl && pdfUrl.includes('docs.google.com/gview')) {
//       try {
//         const urlParams = new URLSearchParams(new URL(pdfUrl).search);
//         pdfUrl = urlParams.get('url');
//       } catch (e) {
//         console.error("Error parsing URL:", e);
//       }
//     }

//     // Navigate to PDF viewer with the document data
//     navigate('/pdf-viewer', {
//       state: {
//         pdfUrl: pdfUrl,
//         title: doc.title
//       }
//     });
//   };

//   // Get display category name
//   const getDisplayCategory = () => {
//     if (filter.mainCategory) return filter.mainCategory;
//     if (selectedCategory) return selectedCategory;
//     return "All Documents";
//   };

//   return (
//     <div className={styles.documentListScreenContainer}>
//       <div className={styles.documentListScreenHeader}>
//         <button className={styles.documentListScreenBackButton} onClick={handleBack}>
//           <FaArrowLeft />
//         </button>
//         <div className={styles.documentListScreenSearchContainer}>
//           <input
//             type="text"
//             className={styles.documentListScreenSearchInput}
//             placeholder={`Search in ${getDisplayCategory()}`}
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//           <button className={styles.documentListScreenSearchButton} onClick={fetchDocuments}>
//             <FaSearch />
//           </button>
//         </div>
//       </div>

//       <h2 className={styles.documentListScreenTitle}>
//         {filteredDocs.length} Documents in {getDisplayCategory()}
//         {filter.subCategory && ` > ${filter.subCategory}`}
//         {filter.subSubCategory && ` > ${filter.subSubCategory}`}
//       </h2>

//       <div className={styles.documentListScreenList}>
//         {loading ? (
//           <p>Loading documents...</p>
//         ) : filteredDocs.length === 0 ? (
//           <p>No documents found.</p>
//         ) : (
//           filteredDocs.map((doc) => (
//             <div
//               key={doc.srNo || doc.id || Math.random()}
//               onClick={() => handleDocumentClick(doc)}
//               className={styles.documentListScreenCard}
//               style={{ cursor: 'pointer' }}
//             >
//               <div className={styles.documentListScreenIconBox}>
//                 <FaFilePdf />
//               </div>
//               <div className={styles.documentListScreenDocInfo}>
//                 <p className={styles.documentListScreenDocTitle}>{doc.title}</p>
//                 <p className={styles.documentListScreenDocDate}>Date: {doc.date}</p>
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       <button
//         className={`${styles.documentListScreenFloatIcon} ${styles.documentListScreenCalculator}`}
//         onClick={handleCalculatorClick}
//       >
//         <FaCalculator />
//       </button>

//       <button
//         className={`${styles.documentListScreenFloatIcon} ${styles.documentListScreenFilter}`}
//         onClick={() => setShowFilter(true)}
//       >
//         <FontAwesomeIcon icon={faFilterIcon} />
//       </button>

//       {showFilter && <FilterPopup onClose={() => setShowFilter(false)} />}
//     </div>
//   );
// }





import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { 
  ArrowLeft, 
  Search, 
  FileText, 
  Calculator, 
  Filter, 
  ChevronRight, 
  Calendar,
  Loader2,
  FileSearch
} from "lucide-react";
import { useAppContext } from "../context";
import FilterPopup from "../components/FilterPopup";
import axios from "axios";

export default function DocumentList() {
  const navigate = useNavigate();
  const { selectedCategory, searchText, setSearchText, filter, setFilter, setSelectedCategory } = useAppContext();
  const [showFilter, setShowFilter] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  
  const navigationSource = useRef(null);

  useEffect(() => {
    if (selectedCategory && !filter.mainCategory) {
      navigationSource.current = 'tab';
    } else if (filter.mainCategory) {
      navigationSource.current = 'filter';
      if (selectedCategory !== filter.mainCategory) {
        setSelectedCategory(filter.mainCategory);
      }
    }
    if (searchText) setSearchTerm(searchText);
  }, []);

  useEffect(() => {
    if (searchText) setSearchTerm(searchText);
  }, [searchText]);

  useEffect(() => {
    fetchDocuments();
  }, [selectedCategory, filter, searchTerm]);

  const fetchDocuments = async () => {
    setLoading(true);
    try {
      const effectiveCategory = filter.mainCategory || selectedCategory || '';
      const params = {
        category: effectiveCategory,
        subCategory: filter.subCategory || '',
        subSubCategory: filter.subSubCategory || '',
        search: searchTerm || ''
      };

      const response = await axios.get("https://tph-api-server2.vishvaconnect.site/getDocuments.php", { params });
      setDocuments(response.data);
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
    setLoading(false);
  };

  const handleBack = () => {
    setFilter({ mainCategory: "", subCategory: "", subSubCategory: "" });
    setSelectedCategory(null);
    setSearchText("");
    navigate("/");
  };

  const handleDocumentClick = (doc) => {
    let pdfUrl = doc.downloadLink;
    if (pdfUrl && pdfUrl.includes('docs.google.com/gview')) {
      try {
        const urlParams = new URLSearchParams(new URL(pdfUrl).search);
        pdfUrl = urlParams.get('url');
      } catch (e) {
        console.error("Error parsing URL:", e);
      }
    }
    navigate('/pdf-viewer', { state: { pdfUrl, title: doc.title } });
  };

  const getDisplayCategory = () => {
    if (filter.mainCategory) return filter.mainCategory;
    if (selectedCategory) return selectedCategory;
    return "All Documents";
  };

  const filteredDocs = documents.filter(doc =>
    searchTerm.trim() === "" || doc.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-[#f8fafc] text-slate-900">
      {/* --- TOP STICKY HEADER --- */}
      <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-20 flex items-center gap-4">
          <button 
            onClick={handleBack}
            className="p-3 hover:bg-slate-100 rounded-xl transition-colors text-slate-600"
          >
            <ArrowLeft size={24} />
          </button>

          <div className="flex-1 relative group">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-orange-500 transition-colors" size={20} />
            <input
              type="text"
              placeholder={`Search in ${getDisplayCategory()}...`}
              className="w-full bg-slate-100 border-none rounded-2xl py-3 pl-12 pr-4 focus:ring-2 focus:ring-orange-500/20 focus:bg-white transition-all outline-none text-sm md:text-base"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        {/* --- BREADCRUMBS & COUNTER --- */}
        <div className="mb-8">
          <div className="flex flex-wrap items-center gap-2 text-xs md:text-sm font-medium text-slate-500 mb-2 uppercase tracking-wider">
            <span>Library</span>
            <ChevronRight size={14} />
            <span className="text-orange-600 font-bold">{getDisplayCategory()}</span>
            {filter.subCategory && (
              <>
                <ChevronRight size={14} />
                <span className="text-slate-800">{filter.subCategory}</span>
              </>
            )}
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-slate-900">
            {loading ? "Searching..." : `${filteredDocs.length} Results Found`}
          </h2>
        </div>

        {/* --- DOCUMENT LIST --- */}
        <div className="grid grid-cols-1 gap-4">
          {loading ? (
            <div className="flex flex-col items-center justify-center py-20 text-slate-400">
              <Loader2 className="animate-spin mb-4" size={48} />
              <p className="font-medium animate-pulse">Fetching latest documents...</p>
            </div>
          ) : filteredDocs.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-slate-400 border-2 border-dashed border-slate-200 rounded-[2rem]">
              <FileSearch size={64} strokeWidth={1} className="mb-4 opacity-20" />
              <p className="text-lg font-bold">No documents match your search</p>
              <button onClick={() => setSearchTerm("")} className="mt-4 text-orange-600 font-bold hover:underline">Clear Search</button>
            </div>
          ) : (
            filteredDocs.map((doc) => (
              <div
                key={doc.srNo || doc.id || Math.random()}
                onClick={() => handleDocumentClick(doc)}
                className="group bg-white border border-slate-100 p-4 md:p-6 rounded-3xl flex items-center gap-4 md:gap-6 cursor-pointer transition-all hover:shadow-xl hover:shadow-slate-200/50 hover:-translate-y-1 active:scale-[0.98]"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 bg-orange-50 text-orange-600 rounded-2xl flex items-center justify-center transition-colors group-hover:bg-orange-600 group-hover:text-white">
                  <FileText size={28} />
                </div>
                
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-lg font-bold text-slate-800 truncate mb-1 group-hover:text-orange-600 transition-colors">
                    {doc.title}
                  </h3>
                  <div className="flex items-center gap-4 text-xs md:text-sm text-slate-400 font-medium">
                    <div className="flex items-center gap-1.5">
                      <Calendar size={14} />
                      <span>{doc.date || "N/A"}</span>
                    </div>
                    <div className="hidden sm:block px-2 py-0.5 bg-slate-100 rounded text-[10px] uppercase">
                      {doc.category || getDisplayCategory()}
                    </div>
                  </div>
                </div>

                <div className="hidden md:flex items-center justify-center w-10 h-10 rounded-full bg-slate-50 text-slate-300 group-hover:bg-orange-100 group-hover:text-orange-600 transition-all">
                  <ChevronRight size={20} />
                </div>
              </div>
            ))
          )}
        </div>
      </main>

      {/* --- FLOATING ACTIONS --- */}
      <div className="fixed bottom-8 right-8 flex flex-col gap-4">
        <button
          className="w-14 h-14 bg-white text-slate-900 border border-slate-200 rounded-2xl shadow-xl flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all transform hover:-translate-y-1"
          onClick={() => navigate("/area-convertor")}
        >
          <Calculator size={24} />
        </button>

        <button
          className="w-14 h-14 bg-orange-600 text-white rounded-2xl shadow-xl flex items-center justify-center hover:bg-orange-700 transition-all transform hover:-translate-y-1"
          onClick={() => setShowFilter(true)}
        >
          <Filter size={24} />
        </button>
      </div>

      {showFilter && <FilterPopup onClose={() => setShowFilter(false)} />}
    </div>
  );
}